/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { Alert, Button, Modal, ModalHeader, ModalBody, ModalFooter, Input } from 'reactstrap';
import { useTranslator, callNativeMobileApp } from '@front-activerse/common-components';
import { useOutletContext } from 'react-router-dom';

const HydrationAddButton = ({ value = undefined, unit, add, messages, className = '' }) => {
  const getCustomValue = () => {
    if (unit === 'ml') {
      return 900;
    } else if (unit === 'cl') {
      return 90;
    } else if (unit === 'oz') {
      return 32;
    }
  };

  const [customValue, setCustomValue] = useState(getCustomValue());
  const [showModal, setShowModal] = useState(false);
  const { trackFirebaseEvent } = useOutletContext();

  const { t } = useTranslator();

  const mililiterOptions = {
    min: 100,
    step: 100,
    max: 1600,
  };

  const centyliterOptions = {
    min: 10,
    step: 10,
    max: 160,
  };

  const ounceOptions = {
    min: 4,
    step: 4,
    max: 56,
  };

  useEffect(() => {
    setCustomValue(getCustomValue());
  }, [unit]);

  const getOptions = () => {
    if (unit === 'ml') {
      return mililiterOptions;
    } else if (unit === 'cl') {
      return centyliterOptions;
    } else if (unit === 'oz') {
      return ounceOptions;
    } else {
      throw new Error(`Unsupported unit: ${unit}`);
    }
  };

  const toggle = () => {
    setShowModal(!showModal);
  };

  const handleInputChange = (event) => {
    const valInt = parseInt(event.target.value, 10);
    setCustomValue(valInt);
  };

  const handleSubmit = async () => {
    if (value) {
      await add(value, unit);

      trackFirebaseEvent('user_action', {
        action: 'tap-add_water',
        amount: value,
        unit: unit,
      });

      callNativeMobileApp({
        action: 'refresh_data',
        payload: {
          module: 'hydration',
        },
      });
    } else {
      toggle();
    }
  };

  const addPortion = async () => {
    toggle();
    await add(customValue, unit);

    trackFirebaseEvent('user_action', {
      action: 'tap-add_water',
      amount: customValue,
      unit: unit,
    });

    callNativeMobileApp({
      action: 'refresh_data',
      payload: {
        module: 'hydration',
      },
    });
  };

  const renderMessages = () => {
    return messages.map((msg) => (
      <Alert key={msg} color="danger" fade={false}>
        {msg}
      </Alert>
    ));
  };

  const { min, step, max } = getOptions();

  return (
    <React.Fragment>
      {renderMessages()}
      <Button
        color="primary"
        onClick={handleSubmit}
        className={`add-btn ${className}`}
        data-testid="hydration-add-button"
      >
        {value ? `${value} ${unit}` : t('hydration.addWater.button.own')}
      </Button>

      <Modal
        className="hydration"
        isOpen={showModal}
        toggle={toggle}
        centered
        size="lg"
        data-testid="hydration-add-modal"
      >
        <ModalHeader toggle={toggle} />
        <ModalBody>
          <h2 className="title-medium semi-bold text-center">
            {t('hydration.ownPortionPopup.headline')}
          </h2>
          <h1 className="medium text-center mb-m">
            <span className="hydration-portion-value">{customValue}</span>{' '}
            <span className="title-medium text-text-variant-color">{unit}</span>
          </h1>
          <Input
            className="hydration custom-range"
            type="range"
            name="value"
            id="value"
            min={min}
            max={max}
            unit={unit}
            step={step}
            style={{
              '--value': `${((customValue - min) / (max - min)) * 100}%`,
            }}
            value={customValue}
            onChange={handleInputChange}
            data-testid="hydration-add-modal-range"
          />
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={addPortion}
            className="add-btn"
            data-testid="hydration-add-modal-button"
          >
            {t('hydration.ownPortionPopup.button')}
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

export default HydrationAddButton;
